import { createContext, useEffect, useState } from "react";

export const SidebarContext = createContext();

export const SidebarContextProvider = ({ children, adminPermissions }) => {
    const [isSidebar, toggleSidebar] = useState(
        JSON.parse(localStorage.getItem("isSidebar")) || false
    );

    const toggle = () => toggleSidebar(!isSidebar);

    useEffect(() => {
        localStorage.setItem("isSidebar", isSidebar);
    }, [isSidebar]);

    return (
        <SidebarContext.Provider value={{ isSidebar, toggle, adminPermissions }}>
            {children}
        </SidebarContext.Provider>
    );
};
